import React, {useEffect} from 'react';

const AnimatedHeroText = ({ children }) => {

  useEffect(() => {
    console.log(children[0].type.name);

  }, []);

  return (
    <div className="pod-animated-hero-text">
      {children}
    </div>
  );
};

export default AnimatedHeroText;
